export enum UserTypeEnum {
    LocationOwner = 5,
    AdvertiserAgency = 6,
    AdvertiserBrand = 7,
    Investor = 8,
    Broker = 9,
    LocationAgent = 10,
    Sponsor = 11,
    SponsorAgent = 12,
    AdvertiserAgent = 13,
    Ab = 14,
    Bb = 15,
    Buffer = 16,
}

export enum CampaignStatusEnum {
    draft = 0,
    onConfirmation = 1,
    canceled = 2,
    scheduled = 3,
    active = 4,
    archive = 5,
    blocked = 6,
    completed = 7
}

